import { AppState } from 'src/app/store'

export const offsetReasonListSelector = (state: AppState) => state.offsetReasons.all
